import { render } from "./cell.vue?vue&type=template&id=71ffc0ed"
import script from "./cell.vue?vue&type=script&lang=js"
export * from "./cell.vue?vue&type=script&lang=js"

import "./cell.vue?vue&type=style&index=0&id=71ffc0ed&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__